import { ApiEpBillingAccount } from "./account";
import { ApiEpBillingActivefeature } from "./activefeature";
import { ApiEpBillingAffiliate } from "./affiliate";
import { ApiEpBillingBill } from "./bill";
import { ApiEpBillingCurrentPlansubscription } from "./current_plansubscription";
import { ApiEpBillingFeature } from "./feature";
import { ApiEpBillingLimit } from "./limit";
import { ApiEpBillingPaymentProvider } from "./payment_provider";
import { ApiEpBillingPlansubscription } from "./plansubscription";
import { ApiEpBillingPolicy } from "./policy";
import { ApiEpBillingProduct } from "./product";
import { ApiEpBillingPromocode } from "./promocode";
import { ApiEpBillingRecurringPayment } from "./recurring_payment";
import { ApiEpBillingSellClassicStock } from "./sell_classic_stock";
import { ApiEpBillingSplit } from "./split";
import { ApiEpBillingUpdate } from "./update";
export const ApiEpBilling = {
    Account: ApiEpBillingAccount,
    Activefeature: ApiEpBillingActivefeature,
    Affiliate: ApiEpBillingAffiliate,
    Bill: ApiEpBillingBill,
    CurrentPlansubscription: ApiEpBillingCurrentPlansubscription,
    Feature: ApiEpBillingFeature,
    Limit: ApiEpBillingLimit,
    PaymentProvider: ApiEpBillingPaymentProvider,
    Plansubscription: ApiEpBillingPlansubscription,
    Policy: ApiEpBillingPolicy,
    Product: ApiEpBillingProduct,
    Promocode: ApiEpBillingPromocode,
    RecurringPayment: ApiEpBillingRecurringPayment,
    SellClassicStock: ApiEpBillingSellClassicStock,
    Split: ApiEpBillingSplit,
    Update: ApiEpBillingUpdate,
};
//# sourceMappingURL=billing.js.map